/* eslint-disable max-lines */
import React from "react";
import { Container } from "reactstrap";
import Typography from "src/components/Typography";
import classes from "./styles.module.scss";

const TermsConditions = () => {
  return (
    <>
      <Container>
        <div className={classes.wrapper}>
          <Typography className={classes.title}>
            Unit 5 Industries Terms and Conditions
          </Typography>
          <Typography variant="p20">
            By utilizing this website to engage the services of Unit 5
            Industries, LLC (“Unit 5 Industries,” “Vendor,” or “Us”), You the
            Customer hereby acknowledge that You are entering a binding
            agreement with Us (the “Agreement”); that the following terms and
            conditions comprise the Agreement; that these terms and conditions
            have been read by You; and that they shall be binding on the parties
            and shall govern the rights and obligations of both You and Unit 5
            Industries, to wit:
          </Typography>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Acceptance of Contract:
            </Typography>
            <Typography variant="p20">
              Acceptance of Contract. Acceptance of this Agreement is limited to
              the terms stated herein. The terms of this Agreement are
              applicable solely on a “per transaction” basis. These terms and
              conditions are subject to change at any time in the sole
              discretion of Unit 5 Industries and, once modified, shall be
              applicable to any future requests for services by Customer to Unit
              5 Industries.
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              The Work:
            </Typography>
            <Typography variant="p20">
              The Work. In exchange for the payment made by Customer as set
              forth by the payment section of the Unit 5 Industries website,
              Unit 5 Industries agrees to attempt, using commercially reasonable
              efforts (including but not limited to proprietary data, methods,
              processes, or test procedures), to identify the provenance of the
              roofing or construction material sample(s) provided by Customer
              and, where applicable, to conduct independent product testing.
              Customer will receive a written report setting forth the findings
              of Unit 5 Industries’ analysis and/or testing in its standard
              report format, as may be updated from time to time in Unit 5
              Industries’ sole discretion.
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Disclaimers & Indemnity:
            </Typography>
            <ol>
              <li>
                <Typography variant="p20">
                  The accuracy of Unit 5 Industries’ identifications or testing
                  results is dependent on the condition of the materials or
                  samples, as well as the accuracy and completeness of
                  information provided by Customer. Customer acknowledges that
                  Unit 5 Industries is not responsible for and cannot control
                  (i) the condition of sample(s) or damage thereto incurred
                  prior to receipt by Unit 5 Industries; (ii) any damage
                  attributable to any delivery service or common carrier
                  responsible for transporting the sample(s); iii) natural
                  degradation of the sample(s) due to age, ordinary wear and
                  tear, or exposure to the elements; or (iv) other damage not
                  attributable to the conduct of Unit 5 Industries that may
                  impair Unit 5 Industries’ ability to conduct accurate testing
                  or identification. Any reports, conclusions, identifications,
                  test findings, or analyses provided under this Agreement are
                  intended solely for the informational use of Customer.
                </Typography>
              </li>
              <li>
                <Typography variant="p20">
                  Customer agrees that Unit 5 Industries shall not be liable for
                  claims, causes of action, costs, damages (property, personal
                  injury, consequential, etc.), or any expenses (including
                  attorney fees) whatsoever attributable to Customer’s use,
                  reliance upon, or dissemination of Unit 5 Industries’ reports,
                  conclusions, identifications, test findings, or analyses,
                  including for the resolution of legal claims by litigation,
                  negotiation, or alternative dispute resolution.
                </Typography>
              </li>
              <li>
                <Typography variant="p20">
                  Customer agrees that Unit 5 Industries shall not be liable for
                  any claims, causes of action, costs, damages (property,
                  personal injury, consequential, etc.), or any expenses
                  (including attorney fees) asserted by any third party
                  whatsoever attributable to the reports, conclusions,
                  identifications, test findings, or analyses provided by Unit 5
                  Industries pursuant to this Agreement. This includes, but is
                  not limited to, claims by property owners, contractors,
                  manufacturers, or insurers regarding the use, interpretation,
                  or reliance on said reports or findings. Customer agrees to
                  indemnify Unit 5 Industries and hold Unit 5 ndustries harmless
                  to the greatest extent allowed by applicable law from any such
                  claims, causes of action, costs, damages, or expenses
                  (including attorney fees).
                </Typography>
              </li>
              <li>
                <Typography variant="p20">
                  Unit 5 Industries does not provide engineering, architectural,
                  or legal services, nor does Unit 5 Industries make
                  recommendations for repairs, design changes, code compliance,
                  or material selection based upon its reports, conclusions,
                  identifications, test findings, or analyses. Any actions taken
                  by Customer or third parties as a result of any testing or
                  identification performed by Unit 5 Industries are solely at
                  their own risk.
                </Typography>
              </li>
              <li>
                <Typography variant="p20">
                  All samples, photographs, documents, or other information
                  provided to Unit 5 Industries by Customer pursuant to this
                  Agreement become the property of Unit 5 Industries. Unit 5
                  Industries makes no warranty or representation as to the time
                  it will retain such samples, photographs, documents, or other
                  information.
                </Typography>
              </li>
            </ol>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Fee Schedule for Additional Services Required of Unit 5
              Industries:
            </Typography>
            <Typography variant="p20">
              Customer agrees that the fee it is paying to Unit 5 Industries for
              its initial reports, conclusions, identifications, test findings,
              or analyses does not cover time or resources spent by Unit 5
              Industries for additional tasks relating to this Agreement such as
              responding to subpoenas, testifying (whether by deposition or in
              court), compiling or producing documents pursuant to subpoenas,
              court orders, or other legal process, or the time spent preparing
              for any of the above. Customer agrees to compensate Unit 5
              Industries at a rate of $350 per man-hour (billed in 0.1 hour
              increments) for time spent compiling and/or producing responses to
              subpoenas or other requests for production of documents by
              Customer or its agents. Customer further agrees to compensate Unit
              5 Industries at a rate of $500 per man-hour (billed in 0.1 hour
              increments) for testimony, whether by deposition or in court.
              Customer further agrees to pay reasonable travel costs and outside
              vendor costs actually incurred, if required to comply with such a
              request. The above fees are applicable regardless of whether such
              request originates with Customer or an adverse party.
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Notice of Third Party Disputes:
            </Typography>
            <Typography variant="p20">
              Customer shall promptly notify Unit 5 Industries should it
              determine that the veracity of any of Unit 5 Industries’
              conclusions, identifications, or test findings are in dispute by
              an adverse party to any litigation, or if litigation appears
              imminent over a dispute in which Unit 5 Industries’ findings would
              be at issue.
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Dispute Resolution:
            </Typography>
            <Typography variant="p20">
              In the event there is a dispute or claim made against Unit 5
              Industries by Customer relating to this Agreement or any work
              performed or contemplated herein, Unit 5 Industries may at its
              election demand the dispute be referred to mediation and, if
              unsettled by mediation, to binding arbitration using the
              Construction Industry Arbitration Rules of the American
              Arbitration Association. Any such proceedings shall solely and
              exclusively be conducted in Denton County, Texas. This Agreement
              may be pled in bar of any litigation instituted by Customer
              against Unit 5 Industries for any claims arising under this
              Agreement. However, should litigation be commenced Customer
              stipulates and agrees that the state courts of Denton County,
              Texas shall be the sole and exclusive forum for any such disputes
              not arbitrated, and hereby submits itself to the personal
              jurisdiction of the State of Texas for purposes of any such
              litigation.
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Legal Costs:
            </Typography>
            <Typography variant="p20">
              In the event of any suit, action, proceeding, or arbitration
              brought to enforce any term of this Agreement, or to redress a
              material breach thereof, the prevailing party at the conclusion of
              such proceeding shall be entitled to recover from the losing party
              any and all reasonable costs including attorney fees incurred by
              the prevailing party in the prosecution and/or defense of such
              suit, action, proceeding, or arbitration.
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Force Majeure:
            </Typography>
            <Typography variant="p20">
              In no event shall Unit 5 Industries be responsible or liable for
              any failure or delay in the performance of its obligations
              hereunder arising out of or caused by, directly or indirectly,
              forces beyond its control, including, without limitation, strikes,
              epidemic disease outbreaks, work stoppages, accidents, acts of war
              or terrorism, civil or military disturbances, nuclear or natural
              catastrophes or acts of God, loss or malfunctions of utilities,
              communications or computer (software and hardware) services, or
              interruptions to essential supply chains. Upon the occurrence of a
              “force majeure” event, Unit 5 Industries shall use reasonable
              efforts which are consistent with accepted practices in the
              testing and construction material analysis industry to resume
              performance as soon as practicable under the circumstances;
              however, if such efforts are impractical and remain so for a
              period of at least 30 days, Unit 5 Industries may without penalty
              terminate the agreement reflected by this Agreement and shall have
              no further obligation to Customer respecting completion of the
              Work.
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Entire Agreement:
            </Typography>
            <Typography variant="p20">
              These terms and conditions, together with the terms for Customer’s
              payment set forth by the Unit 5 Industries website, shall
              constitute the entire agreement between the parties. The terms and
              conditions that govern the provision of the goods or services
              described in this Agreement are limited to the terms and
              conditions specified herein, and formation of any contract is
              expressly made conditional on Customer’s assent to these terms.
              These terms and conditions supersede all prior discussions,
              agreements, representations, and agreements. Unit 5 Industries
              will not be bound by any additional, different, or inconsistent
              terms in acknowledgements, invoices, or other documents from
              Customer or by any course of conduct between the parties
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Governing Law:
            </Typography>
            <Typography variant="p20">
              This Agreement shall be construed and interpreted in accordance
              with the laws of the State of Texas.
            </Typography>
          </div>

          <div>
            <Typography className={classes.subTitle} variant="p24">
              Authority and Reliance:
            </Typography>
            <Typography variant="p20">
              Unit 5 Industries and Customer each warrant and represent that:
              (i) they have relied upon their own judgment regarding the
              consideration for and language of this Agreement; (ii) this
              Agreement is written in a manner that is understandable and that
              they have read all of the paragraphs of this Agreement. Each party
              further acknowledges that they are entering into this Agreement
              freely, knowingly, voluntarily, with a full understanding of its
              terms, and with the intent to form a binding contract. Each party
              warrants and represents that the party is not relying on counsel
              for any other party for the performance of any task, provision of
              any service or rendering of any advice for any purpose whatsoever,
              but instead is relying solely and exclusively on the party’s own
              counsel for all matters relating to the terms of this Agreement.
            </Typography>
          </div>
        </div>
      </Container>
    </>
  );
};

export default TermsConditions;
